<header>
    <div class="heading-border-box">
        <p>Demo - "BAT" (BADLA ANALYTICS TOOL) </p>
        <!-- <p> account  </p> -->
        <div class="main-hedar-box" >
            <div class="thim-chajing-box">
                <input type="checkbox" class="checkbox"  [(ngModel)]="isChecked"  id="checkbox" (change)="changeTheme(isChecked?'A':'B')"/>
              <label for="checkbox" class="label">
                <i class="fas fa-moon"></i>
                <i class="fas fa-sun"></i>
                <div class="ball"></div>
              </label>
            </div>
    
            
            <button  class="btn but-box btn-danger p-0 m-0" id="logoutBtn" (click)="logout()">
                    Logout  <i class="far fa-sign-out-alt"></i> 
            </button>    
        </div>
    </div>
</header>